/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { newResourceRequestSchema } from './newResourceRequestSchema';

export const openPositionConvertRequestSchema = z.object({
  autoSplit: z.boolean(),
  get newResource() {
    return z.union([newResourceRequestSchema, z.null()]).optional();
  },
  resourceId: z.int().nullish(),
});
